import { render, staticRenderFns } from "./config.vue?vue&type=template&id=56cdc4bc&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=56cdc4bc&prod&scoped=true&lang=scss"
import style1 from "./config.vue?vue&type=style&index=1&id=56cdc4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cdc4bc",
  null
  
)

export default component.exports